import script from "./Newknowledgeindex.vue?vue&type=script&setup=true&lang=js"
export * from "./Newknowledgeindex.vue?vue&type=script&setup=true&lang=js"

import "./Newknowledgeindex.vue?vue&type=style&index=0&id=2f140566&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f140566"]])

export default __exports__